import MySimpleSpinner from "@common-utils/MySimpleSpinner"

// Loader centré verticalement et horizontalement (pages demande d'embauche).
const CenteredLoader = ({ text, minHeight = "60vh" }: { text?: string; minHeight?: string }) => (
     <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight }}>
          <MySimpleSpinner size="xl" text={text} />
     </div>
)

export default CenteredLoader
